import { useState } from "react";
import cn from "classnames";

import css from "./styles.module.scss";

export const TextInput = ({
  label,
  value,
  setValue,
  error,
  type,
  autoComplete,
  placeholder,
  mode = "form",
  step,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const inputType =
    type === "date" ? (isFocused ? "date" : "text") : type || "text";

  return (
    <div className={cn(css.className, css.TextInput)}>
      <div
        className={cn({
          [css.inputContainerForm]: mode === "form",
          [css.inputContainerClasses]: mode === "classes",
        })}
      >
        {label && (
          <div className={css.labelContainer}>
            <label htmlFor={label} className={css.label}>
              {label}
            </label>
          </div>
        )}
        <input
          id={label}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={cn({
            [css.inputForm]: mode === "form",
            [css.inputClasses]: mode === "classes",
            [css.errorInput]: error,
          })}
          type={inputType}
          autoComplete={autoComplete}
          placeholder={placeholder}
          step={step || 1}
        />
      </div>
      {error && <p className={css.errorText}>{error}</p>}
    </div>
  );
};
